import React, { useContext } from 'react';
import loadable from '@loadable/component';
import UserMenu from 'ls-common-client/dist/components/UserMenu';
import AppMenu from 'ls-common-client/dist/components/AppMenu';
import Modal from '../../Modal';
import { Context } from '../../../context/AppContext';
import { MODALS } from '../../../constants';
import FullScreenLoader from '../../FullScreenLoader';
import imageResizer from '../../../services/imageResizer';

const LogoutModal = loadable(() => import('./LogoutModal'), {
  fallback: <FullScreenLoader />,
});

const LoginMenu = () => {
  const {
    user: { user, isStaff },
    modal: { showModal, hideModal },
    auth,
    media: { mobile },
  } = useContext(Context);

  const modalName = MODALS.USER_LOGOUT;

  const onOpen = () => {
    if (mobile) {
      hideModal(MODALS.QUOTE_FORM_POPUP, { hidden: true });
      hideModal(MODALS.ENQUIRY_FORM_POPUP, { hidden: true });
    } else {
      showModal(MODALS.QUOTE_FORM_POPUP, { hidden: true });
      showModal(MODALS.ENQUIRY_FORM_POPUP, { hidden: true });
    }
  };

  const onClose = () => {
    showModal(MODALS.QUOTE_FORM_POPUP, { hidden: true });
    showModal(MODALS.ENQUIRY_FORM_POPUP, { hidden: true });
  };

  return (
    <>
      {auth.token() ? (
        <AppMenu
          marginRight="10px"
          onOpen={onOpen}
          onClose={onClose}
          isStaff={isStaff}
        />
      ) : null}
      <UserMenu
        auth={{ ...auth, logout: () => showModal(modalName) }}
        imageResizer={imageResizer}
        user={user}
        onOpen={onOpen}
        onClose={onClose}
      />
      <Modal
        name={modalName}
        className="UserLogout__Confirmation"
        onClickOutside={() => hideModal(modalName)}
      >
        <LogoutModal />
      </Modal>
    </>
  );
};

export default LoginMenu;
